import { IAppState } from '@state/types';
import { User, UserManager } from 'oidc-client';

export const getAuthUserManager = (state: IAppState): UserManager | undefined => state.auth.userManager;
export const getAuthUser = (state: IAppState): User | undefined => state.auth.user;
export const getShareToken = (state: IAppState): string | undefined => state.auth.shareToken;
export const getAuthToken = (state: IAppState): string | undefined => state.auth.token;

